// Static "About Us" content for the public site, grouped into the four tabs
// shown in the About section. Authored in Arabic; English is a faithful
// translation so the section works in both locales.

const aboutContent = {
  ar: [
    {
      id: 'chairman',
      title: 'كلمة رئيس الاتحاد',
      blocks: [],
    },
    {
      id: 'about',
      title: 'حول الاتحاد',
      blocks: [
        {
          type: 'banner',
          src: 'info/about_union/about_union_bg.png',
          alt: 'اتحاد الغرف التجارية الصناعية الزراعية الفلسطينية',
        },
        {
          type: 'tagline',
          text:
            'اتحاد الغرف التجارية الصناعية الزراعية الفلسطينية — بيت القطاع الخاص الفلسطيني',
        },
        { type: 'h', text: 'الإطار القانوني والتنظيمي' },
        {
          type: 'p',
          text:
            'تمارس الغرف الفلسطينية والاتحاد عملها وفقاً لقانون الغرف التجارية الصناعية الفلسطينية رقم 9 لسنة 2011، ونظام الغرف التجارية الصناعية رقم 2 لسنة 2013.',
        },
        { type: 'h', text: 'نبذة' },
        {
          type: 'p',
          text:
            'تأسس اتحاد الغرف التجارية الصناعية الزراعية الفلسطينية في العام 1989، ويتمتع الاتحاد وفق القانون بالشخصية الاعتبارية المستقلة مالياً وإدارياً وهو المظلة الوطنية للغرف التجارية الصناعية الفلسطينية ويتولى تمثيل الغرف والأعضاء المنتسبين فيها أمام الجهات الرسمية وغير الرسمية محلياً ودولياً، كما يعمل الاتحاد على رعاية مصالح أعضائه والدفاع عن حقوقهم والمشاركة في صياغة ومراجعة وتعديل القوانين والأنظمة والإجراءات ذات الطابع الاقتصادي والتي تتعلق بتسهيل عمل القطاع الخاص الفلسطيني وتوفير البيئة المواتية للاستثمار وضمان أداء القطاع الخاص في بيئة تنافسية استناداً إلى الأعراف والممارسات التجارية الفضلى، إضافة إلى رفع كفاءة وقدرات الغرف التجارية الصناعية وتطوير وتنويع خدماتها.',
        },
        {
          type: 'vision-mission',
          items: [
            {
              label: 'رؤيتنا',
              icon: 'vision',
              text: 'نحو شراكة فاعلة في بناء اقتصاد فلسطيني قوي وقيادة قطاع خاص فاعل ومؤثر، يُسهم في دفع عجلة التنمية الاقتصادية المستدامة، ويُعزز المكانة التنافسية للمنتجات الفلسطينية في الأسواق المحلية والإقليمية والدولية، ويُرسّخ دور القطاع الخاص شريكًا حقيقيًا في بناء المستقبل الاقتصادي لفلسطين.',
            },
            {
              label: 'رسالتنا',
              icon: 'mission',
              text: 'تطوير أداء الغرف التجارية الصناعية وتعزيز مساهمتها في التنمية الاقتصادية من خلال تقديم خدمات نوعية للأعضاء والقطاع الخاص، والتأثير والمشاركة في رسم السياسات والتشريعات الاقتصادية بما يخدم مصلحة القطاع الخاص وتعزيز علاقات الغرف على المستوى المحلي والإقليمي والدولي والترويج للمنتجات الفلسطينية محلياً ودولياً.',
            },
          ],
        },
        { type: 'h', text: 'الأهداف الاستراتيجية للاتحاد' },
        {
          type: 'goals-grid',
          items: [
            'تطوير البناء المؤسسي للاتحاد والغرف.',
            'العمل على تطوير نوعية الخدمات المقدمة.',
            'تعزيز واستثمار العلاقات المحلية والإقليمية والدولية للاتحاد.',
            'المزيد من الضغط والمناصرة لمصلحة القطاع الخاص.',
          ],
        },
        { type: 'h', text: 'مهام الاتحاد' },
        {
          type: 'tasks-timeline',
          items: [
            'تمثيل الغرف أمام أية جهة رسمية أو غير رسمية داخل فلسطين أو خارجها.',
            'المشاركة مع الجهات ذات العلاقة في المؤتمرات الاقتصادية، وفي الأنشطة المحلية والعربية والدولية ذات الطابع الاقتصادي.',
            'رعاية مصالح أعضائه والدفاع عن حقوقهم ومتابعة أدائهم وفقاً لأحكام القانون.',
            'القيام بالدراسات والبحوث ذات العلاقة بالأمور الاقتصادية ونشرها وتحديثها.',
            'جمع المعلومات والإحصاءات المتعلقة بالتجارة والصناعة وتبويبها وتحديثها وتزويد الأعضاء بها، وإنشاء مركز للمعلومات لتوفير أحدث البرامج المتعلقة بالأمور الاقتصادية بالتعاون مع مراكز المعلومات المحلية والعربية والدولية.',
            'تقديم المقترحات الخاصة بالتشريعات القائمة، ومشروعات القوانين والأنظمة ذات العلاقة بالتجارة والصناعة والاقتصاد بشكل عام.',
            'تقديم المشورة الفنية والتقنية فيما يتعلق بالأمور الاقتصادية والاستعانة لهذه الغاية بالخبراء والاقتصاديين.',
            'إقرار الهيكل الإداري والتنظيمي للاتحاد.',
            'أية مهام أخرى ذات علاقة بأهدافه.',
          ],
        },
      ],
    },
    {
      id: 'members',
      title: 'أعضاء الاتحاد',
      blocks: [
        { type: 'h', text: 'العضوية في الاتحاد' },
        {
          type: 'p',
          text:
            'يضم الاتحاد 18 غرفة تجارية صناعية موزعة جغرافياً من جنين شمالاً إلى رفح جنوباً، وتمثل في مجموعها ما يزيد عن 65000 عضو من مختلف القطاعات الاقتصادية من المنشآت الصغيرة والمتوسطة والكبيرة على حد سواء.',
        },
        {
          type: 'p',
          text:
            'تعتبر العضوية في الاتحاد إلزامية لكافة الغرف الفلسطينية كما تعتبر العضوية في الغرف التجارية الصناعية إلزامية بموجب القانون:',
        },
        {
          type: 'links',
          items: [
            { label: 'قانون الغرف التجارية الصناعية الفلسطينية رقم 9 لسنة 2011', href: '#' },
            { label: 'نظام الغرف التجارية الصناعية رقم 2 لسنة 2013', href: '#' },
          ],
        },
        { type: 'h', text: 'الغرف الفلسطينية الأعضاء' },
        {
          type: 'chambers',
          subtitle:
            'تضم شبكة اتحاد الغرف التجارية الصناعية الزراعية الفلسطينية جميع الغرف التجارية والصناعية والزراعية في محافظات الوطن.',
          items: [
            { name: 'غرفة تجارة وصناعة نابلس', location: 'نابلس', src: 'info/member_union/نابلس.png', href: 'https://nablus-chamber.org/' },
            { name: 'غرفة تجارة وصناعة شمال غزة', location: 'شمال غزة', src: 'info/member_union/شمال-غزة.png', href: 'https://www.facebook.com/ngchamberps' },
            { name: 'غرفة تجارة وصناعة شمال الخليل', location: 'شمال الخليل', src: 'info/member_union/شمال-الخليل.png', href: 'http://www.nhcci.ps/' },
            { name: 'غرفة تجارة وصناعة القدس', location: 'القدس', src: 'info/member_union/القدس.png', href: 'http://www.jacci.org/' },
            { name: 'غرفة تجارة وصناعة سلفيت', location: 'سلفيت', src: 'info/member_union/سلفيت.png', href: 'https://www.facebook.com/SalfitChamber/' },
            { name: 'غرفة تجارة وصناعة رفح', location: 'رفح', src: 'info/member_union/رفح.png', href: 'http://cci-rafah.ps/Account/Login' },
            { name: 'غرفة تجارة وصناعة طولكرم', location: 'طولكرم', src: 'info/member_union/طولكرم.png', href: 'http://www.nhcci.ps/' },
            { name: 'غرفة تجارة وصناعة خانيونس', location: 'خانيونس', src: 'info/member_union/خانيونس.png', href: 'https://www.facebook.com/1456020511284460/' },
            { name: 'غرفة تجارة وصناعة المحافظة الوسطى', location: 'المحافظة الوسطى', src: 'info/member_union/الوسطى.png', href: 'https://www.facebook.com/Middle.Province.Chamber' },
            { name: 'غرفة تجارة وصناعة محافظة غزة', location: 'غزة', src: 'info/member_union/غزة.png', href: 'http://www.gazacham.ps/' },
            { name: 'غرفة تجارة وصناعة أريحا', location: 'أريحا', src: 'info/member_union/اريحا.png', href: 'https://www.facebook.com/jccia' },
            { name: 'غرفة تجارة وصناعة طوباس', location: 'طوباس', src: 'info/member_union/طوباس.png', href: 'https://www.facebook.com/tubasccia/' },
            { name: 'غرفة تجارة وصناعة الظاهرية', location: 'الظاهرية', src: 'info/member_union/الظاهرية.png', href: 'https://www.facebook.com/SHCCI' },
            { name: 'غرفة تجارة وصناعة محافظة الخليل', location: 'الخليل', src: 'info/member_union/الخليل.png', href: 'https://hebroncci.org/new/' },
            { name: 'غرفة تجارة وصناعة محافظة بيت لحم', location: 'بيت لحم', src: 'info/member_union/بيت-لحم.png', href: 'https://www.bethlehem-chamber.org/' },
            { name: 'غرفة تجارة وصناعة قلقيلية', location: 'قلقيلية', src: 'info/member_union/قلقيلية.png', href: 'https://qalqilyacci.org/' },
            { name: 'غرفة تجارة وصناعة رام الله', location: 'رام الله', src: 'info/member_union/رام-الله.png', href: 'http://www.ramallahcci.org/ar' },
            { name: 'غرفة تجارة وصناعة جنين', location: 'جنين', src: 'info/member_union/جنين.png', href: 'https://www.jenincci.org/' },
          ],
        },
      ],
    },
    {
      id: 'structure',
      title: 'الهيكل التنظيمي',
      blocks: [
        {
          type: 'org-structure',
          banner: {
            alt: 'الهيكل التنظيمي لاتحاد الغرف التجارية الصناعية الزراعية الفلسطينية',
            chart: {
              generalAssembly: 'الهيئة العامة',
              council: 'مجلس الاتحاد',
              bureau: 'هيئة المكاتب',
              committees: 'اللجان التمثيلية وممثلي الاتحاد في الهيئات المختلفة',
              president: 'رئيس الاتحاد',
              purpleTop: 'مدقق الحسابات',
              purpleBottom: 'المستشار القانوني',
              auditor: 'مدقق الحسابات',
              secretaryGeneral: 'الأمين العام',
              chambersManagers: 'مدراء الغرف',
              departments: [
                'الشؤون المالية',
                'الشؤون الادارية',
                'النوع الاجتماعي',
                'التدريب المهني',
                'العلاقات العامة',
                'المعلومات والدعم الفني',
              ],
            },
          },
          sections: [
            {
              title: 'الهيئة العامة للاتحاد',
              blocks: [
                {
                  type: 'p',
                  text:
                    'تتألف الهيئة العامة للاتحاد من مجموع أعضاء مجالس إدارات الغرف الفلسطينية كافة.',
                },
                { type: 'p', text: 'وتمارس الهيئة العامة للاتحاد المهام الآتية:' },
                {
                  type: 'ul',
                  items: [
                    'مناقشة سياسة الاتحاد المقدمة إليها من مجلس الاتحاد.',
                    'إقرار مشروع الموازنة السنوية للاتحاد.',
                    'إقرار التقرير السنوي عن أعمال مجلس الاتحاد والحسابات الختامية والميزانية العمومية للاتحاد.',
                    'تعيين مدقق حسابات قانوني لتدقيق حسابات الاتحاد.',
                    'مناقشة الأمور التي يعرضها عليها مجلس الاتحاد واتخاذ التوصيات اللازمة بشأنها.',
                  ],
                },
              ],
            },
            {
              title: 'مجلس الإدارة',
              blocks: [
                {
                  type: 'p',
                  text:
                    'يتألف مجلس الاتحاد من 18 عضواً يمثلون مجموع رؤساء الغرف الفلسطينية كافة. ويتولى مجلس إدارة الاتحاد المهام الآتية:',
                },
                {
                  type: 'ul',
                  items: [
                    'وضع سياسة الاتحاد وخطة عمله والإشراف على تطبيقها.',
                    'إدارة الشؤون الإدارية والمالية للاتحاد.',
                    'تعيين الأمين العام للاتحاد والموظفين لتسيير أعمال الاتحاد.',
                    'العمل على تحقيق أهداف الاتحاد.',
                    'رعاية مصالح الغرف والتنسيق فيما بينها.',
                    'دعوة الهيئة العامة للاتحاد للاجتماع العادي والطارئ.',
                    'المشاركة مع الجهات ذات العلاقة في إعداد مشروعات القوانين والتشريعات الخاصة بالنواحي الاقتصادية.',
                    'أية أمور أخرى تحقق أهداف الاتحاد والاقتصاد الوطني في فلسطين.',
                  ],
                },
                { type: 'p', text: 'كما يتم انتخاب المناصب الإدارية التالية:' },
                {
                  type: 'ul',
                  items: ['رئيس الاتحاد', 'نواب الرئيس', 'أمين السر', 'أمين الصندوق'],
                },
              ],
            },
            {
              title: 'هيئة المكتب',
              blocks: [
                {
                  type: 'p',
                  text:
                    'تتألف من الرئيس ونواب الرئيس وأمين السر وأمين الصندوق، وتتولى متابعة قرارات مجلس الاتحاد.',
                },
              ],
            },
            {
              title: 'الإدارة التنفيذية',
              variant: 'departments',
              blocks: [
                {
                  type: 'ul',
                  items: [
                    'الأمانة العامة',
                    'دائرة العلاقات العامة',
                    'دائرة المعلومات والدعم الفني',
                    'دائرة التدريب المهني والتقني',
                    'وحدة النوع الاجتماعي (صاحبات الأعمال)',
                    'الشؤون الإدارية والموارد البشرية',
                    'الدائرة المالية',
                    'المستشار القانوني',
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],

  en: [
    {
      id: 'chairman',
      title: 'Chairman\u2019s Message',
      blocks: [],
    },
    {
      id: 'about',
      title: 'About the Federation',
      blocks: [
        {
          type: 'banner',
          src: 'info/about_union/about_union_bg.png',
          alt: 'Federation of Palestinian Chambers of Commerce, Industry and Agriculture',
        },
        {
          type: 'tagline',
          text:
            'The Federation of Palestinian Chambers of Commerce, Industry and Agriculture \u2014 the home of the Palestinian private sector.',
        },
        { type: 'h', text: 'Legal and Regulatory Framework' },
        {
          type: 'p',
          text:
            'The Palestinian chambers and the Federation operate in accordance with the Palestinian Chambers of Commerce and Industry Law No. 9 of 2011 and the Chambers of Commerce and Industry Regulation No. 2 of 2013.',
        },
        { type: 'h', text: 'Overview' },
        {
          type: 'p',
          text:
            'The Federation of Palestinian Chambers of Commerce, Industry and Agriculture was established in 1989. Under the law, the Federation enjoys an independent legal personality, financially and administratively, and is the national umbrella for the Palestinian chambers. It represents the chambers and their affiliated members before official and unofficial bodies locally and internationally, looks after its members\u2019 interests and defends their rights, and participates in drafting, reviewing and amending economic laws, regulations and procedures related to facilitating the work of the Palestinian private sector, providing a favourable environment for investment and ensuring private-sector performance in a competitive environment based on best commercial practices \u2014 in addition to raising the efficiency and capacity of the chambers and developing and diversifying their services.',
        },
        {
          type: 'vision-mission',
          items: [
            {
              label: 'Our Vision',
              icon: 'vision',
              text: 'Towards an effective partnership in building a strong Palestinian economy and leading an active, influential private sector — contributing to sustainable economic development, enhancing the competitive position of Palestinian products in local, regional, and international markets, and cementing the private sector\'s role as a true partner in shaping Palestine\'s economic future.',
            },
            {
              label: 'Our Mission',
              icon: 'mission',
              text: 'To develop the performance of the chambers of commerce and industry and enhance their contribution to economic development by delivering quality services to members and the private sector, influencing and participating in shaping economic policies and legislation that serve the private sector\u2019s interests, strengthening the chambers\u2019 relations locally, regionally and internationally, and promoting Palestinian products at home and abroad.',
            },
          ],
        },
        { type: 'h', text: 'Strategic Objectives' },
        {
          type: 'goals-grid',
          items: [
            'Developing the institutional structure of the Federation and the chambers.',
            'Working to improve the quality of services provided.',
            'Strengthening and investing in the Federation\u2019s local, regional and international relations.',
            'More lobbying and advocacy in the interest of the private sector.',
          ],
        },
        { type: 'h', text: 'Functions of the Federation' },
        {
          type: 'tasks-timeline',
          items: [
            'Representing the chambers before any official or unofficial body inside or outside Palestine.',
            'Participating with relevant parties in economic conferences and in local, Arab and international activities of an economic nature.',
            'Caring for its members\u2019 interests, defending their rights and following up on their performance in accordance with the law.',
            'Conducting studies and research related to economic matters and publishing and updating them.',
            'Collecting, classifying and updating trade and industry information and statistics and providing them to members, and establishing an information centre offering the latest economic programmes in cooperation with local, Arab and international information centres.',
            'Submitting proposals on existing legislation and on draft laws and regulations related to trade, industry and the economy in general.',
            'Providing technical advice on economic matters, drawing on experts and economists for this purpose.',
            'Approving the administrative and organisational structure of the Federation.',
            'Any other tasks related to its objectives.',
          ],
        },
      ],
    },
    {
      id: 'members',
      title: 'Membership',
      blocks: [
        { type: 'h', text: 'Membership in the Federation' },
        {
          type: 'p',
          text:
            'The Federation comprises 18 chambers of commerce and industry distributed geographically from Jenin in the north to Rafah in the south, together representing more than 65,000 members across various economic sectors \u2014 small, medium and large enterprises alike.',
        },
        {
          type: 'p',
          text:
            'Membership in the Federation is mandatory for all Palestinian chambers, and membership in the chambers of commerce and industry is mandatory by law.',
        },
        {
          type: 'links',
          items: [
            { label: 'Palestinian Chambers of Commerce and Industry Law No. 9 of 2011', href: '#' },
            { label: 'Chambers of Commerce and Industry Regulation No. 2 of 2013', href: '#' },
          ],
        },
        { type: 'h', text: 'Member Palestinian Chambers' },
        {
          type: 'chambers',
          subtitle:
            'The Federation network includes all commercial, industrial and agricultural chambers across the governorates of Palestine.',
          items: [
            { name: 'Nablus Chamber of Commerce and Industry', location: 'Nablus', src: 'info/member_union/نابلس.png', href: 'https://nablus-chamber.org/' },
            { name: 'North Gaza Chamber of Commerce and Industry', location: 'North Gaza', src: 'info/member_union/شمال-غزة.png', href: 'https://www.facebook.com/ngchamberps' },
            { name: 'North Hebron Chamber of Commerce and Industry', location: 'North Hebron', src: 'info/member_union/شمال-الخليل.png', href: 'http://www.nhcci.ps/' },
            { name: 'Jerusalem Chamber of Commerce and Industry', location: 'Jerusalem', src: 'info/member_union/القدس.png', href: 'http://www.jacci.org/' },
            { name: 'Salfit Chamber of Commerce and Industry', location: 'Salfit', src: 'info/member_union/سلفيت.png', href: 'https://www.facebook.com/SalfitChamber/' },
            { name: 'Rafah Chamber of Commerce and Industry', location: 'Rafah', src: 'info/member_union/رفح.png', href: 'http://cci-rafah.ps/Account/Login' },
            { name: 'Tulkarm Chamber of Commerce and Industry', location: 'Tulkarm', src: 'info/member_union/طولكرم.png', href: 'http://www.nhcci.ps/' },
            { name: 'Khan Younis Chamber of Commerce and Industry', location: 'Khan Younis', src: 'info/member_union/خانيونس.png', href: 'https://www.facebook.com/1456020511284460/' },
            { name: 'Middle Area Chamber of Commerce and Industry', location: 'Middle Area', src: 'info/member_union/الوسطى.png', href: 'https://www.facebook.com/Middle.Province.Chamber' },
            { name: 'Gaza Chamber of Commerce and Industry', location: 'Gaza', src: 'info/member_union/غزة.png', href: 'http://www.gazacham.ps/' },
            { name: 'Jericho Chamber of Commerce and Industry', location: 'Jericho', src: 'info/member_union/اريحا.png', href: 'https://www.facebook.com/jccia' },
            { name: 'Tubas Chamber of Commerce and Industry', location: 'Tubas', src: 'info/member_union/طوباس.png', href: 'https://www.facebook.com/tubasccia/' },
            { name: 'Dhahiriya Chamber of Commerce and Industry', location: 'Dhahiriya', src: 'info/member_union/الظاهرية.png', href: 'https://www.facebook.com/SHCCI' },
            { name: 'Hebron Chamber of Commerce and Industry', location: 'Hebron', src: 'info/member_union/الخليل.png', href: 'https://hebroncci.org/new/' },
            { name: 'Bethlehem Chamber of Commerce and Industry', location: 'Bethlehem', src: 'info/member_union/بيت-لحم.png', href: 'https://www.bethlehem-chamber.org/' },
            { name: 'Qalqilya Chamber of Commerce and Industry', location: 'Qalqilya', src: 'info/member_union/قلقيلية.png', href: 'https://qalqilyacci.org/' },
            { name: 'Ramallah Chamber of Commerce and Industry', location: 'Ramallah', src: 'info/member_union/رام-الله.png', href: 'http://www.ramallahcci.org/ar' },
            { name: 'Jenin Chamber of Commerce and Industry', location: 'Jenin', src: 'info/member_union/جنين.png', href: 'https://www.jenincci.org/' },
          ],
        },
      ],
    },
    {
      id: 'structure',
      title: 'Organisational Structure',
      blocks: [
        {
          type: 'org-structure',
          banner: {
            alt: 'Organisational structure of the Federation of Palestinian Chambers of Commerce, Industry and Agriculture',
            chart: {
              generalAssembly: 'General Assembly',
              council: 'Federation Council',
              bureau: 'Bureau of Offices',
              committees: 'Representative Committees and Federation Representatives in Various Bodies',
              president: 'President of the Federation',
              purpleTop: 'Auditor',
              purpleBottom: 'Legal Advisor',
              auditor: 'Auditor',
              secretaryGeneral: 'Secretary General',
              chambersManagers: 'Chambers Managers',
              departments: [
                'Financial Affairs',
                'Administrative Affairs',
                'Gender',
                'Vocational Training',
                'Public Relations',
                'Information and Technical Support',
              ],
            },
          },
          sections: [
            {
              title: 'General Assembly',
              blocks: [
                {
                  type: 'p',
                  text:
                    'The General Assembly of the Federation consists of all members of the boards of directors of the Palestinian chambers. It carries out the following functions:',
                },
                {
                  type: 'ul',
                  items: [
                    'Discussing the Federation\u2019s policy submitted by the Federation Council.',
                    'Approving the Federation\u2019s annual draft budget.',
                    'Approving the annual report on the Council\u2019s work, the final accounts and the balance sheet.',
                    'Appointing a legal auditor to audit the Federation\u2019s accounts.',
                    'Discussing matters presented by the Federation Council and adopting the necessary recommendations.',
                  ],
                },
              ],
            },
            {
              title: 'Board of Directors',
              blocks: [
                {
                  type: 'p',
                  text:
                    'The Federation Council consists of 18 members representing all chairpersons of the Palestinian chambers. The Board of Directors carries out the following functions:',
                },
                {
                  type: 'ul',
                  items: [
                    'Setting the Federation\u2019s policy and work plan and supervising their implementation.',
                    'Managing the Federation\u2019s administrative and financial affairs.',
                    'Appointing the Secretary-General and staff to run the Federation\u2019s business.',
                    'Working to achieve the Federation\u2019s objectives.',
                    'Caring for the chambers\u2019 interests and coordinating among them.',
                    'Convening the General Assembly for ordinary and emergency meetings.',
                    'Participating with relevant parties in preparing draft economic laws and legislation.',
                    'Any other matters that serve the objectives of the Federation and the national economy in Palestine.',
                  ],
                },
                { type: 'p', text: 'The following administrative positions are also elected:' },
                {
                  type: 'ul',
                  items: ['Chairman', 'Vice-Chairmen', 'Secretary', 'Treasurer'],
                },
              ],
            },
            {
              title: 'Bureau',
              blocks: [
                {
                  type: 'p',
                  text:
                    'Composed of the Chairman, Vice-Chairmen, Secretary and Treasurer, it follows up on the decisions of the Federation Council.',
                },
              ],
            },
            {
              title: 'Executive Management',
              variant: 'departments',
              blocks: [
                {
                  type: 'ul',
                  items: [
                    'Secretariat-General',
                    'Public Relations Department',
                    'Information and Technical Support Department',
                    'Vocational and Technical Training Department',
                    'Gender Unit (Businesswomen)',
                    'Administrative Affairs and Human Resources',
                    'Finance Department',
                    'Legal Advisor',
                  ],
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export default aboutContent;
